import React, { createContext, useContext } from 'react';

import type { PropsWithChildren } from 'react';

const DEFAULT_CONTEXT_VALUE_TAG = Symbol('DEFAULT_CONTEXT_VALUE');

const Context = createContext<unknown>(DEFAULT_CONTEXT_VALUE_TAG);

export const PageContextProvider = <T,>({
  children,
  pageContext,
}: PropsWithChildren<{ pageContext: T }>) => (
  <Context.Provider value={pageContext}>{children}</Context.Provider>
);

export const usePageContext = <T = Record<string, unknown>,>(): T => {
  const pageContext = useContext(Context);

  if (pageContext === DEFAULT_CONTEXT_VALUE_TAG) {
    throw new TypeError('missing `PageContextProvider`');
  }

  return pageContext as T;
};
